var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-3 pt-1"},[_c('div',{staticClass:"text-primary"},[_c('span',{staticClass:"h2",staticStyle:{"line-height":"1"}},[_vm._v(_vm._s(_vm.price))])]),_vm._v(" "),_c('span',{staticClass:"text-primary small bold"},[_vm._v(_vm._s(_vm.billing))])])
}
var staticRenderFns = []

export { render, staticRenderFns }